import type {
  ListCoursesUseCase,
  ListCurriculumsByCourseUseCase,
} from '@/application/port/in/CatalogQueryUseCase';
import type { CatalogReadGateway } from '@/application/port/out/CatalogReadGateway';
import type { CourseSummary, CurriculumSummary } from '@/domain/model/Catalog';

export class ListCoursesUseCaseImpl implements ListCoursesUseCase {
  constructor(private readonly gateway: CatalogReadGateway) {}

  execute(): Promise<CourseSummary[]> {
    return this.gateway.listCourses();
  }
}

export class ListCurriculumsByCourseUseCaseImpl
  implements ListCurriculumsByCourseUseCase
{
  constructor(private readonly gateway: CatalogReadGateway) {}

  execute(courseId: string): Promise<CurriculumSummary[]> {
    if (!courseId) return Promise.resolve([]);
    return this.gateway.listCurriculumsByCourse(courseId);
  }
}
